// extracted by mini-css-extract-plugin
module.exports =  {"person":"J8PIvNyvNi9qYxudbqRd"};